<template>
    <div v-if="showModal" id="parcel_order_modal" class="ui center aligned grid">
        <div class="column">
            <div id="header" class="ui top fixed menu">
                <h3>{{ fileName ? fileName : "엑셀 파일을 선택하세요." }}</h3>
            </div>
            <div id="body" class="scrolling content">
                <table class="ui striped celled compact table">
                    <thead>
                        <tr>
                            <th class="collapsing">#</th>
                            <th class="collapsing">판매처</th>
                            <th class="collapsing">타입</th>
                            <th class="collapsing">택배사</th>
                            <th class="collapsing">운송장번호</th>
                            <th class="collapsing">주문날짜</th>
                            <th class="collapsing">상품명</th>
                            <th class="collapsing">수량</th>
                            <th class="collapsing">주문자</th>
                            <th class="collapsing">주문자연락처</th>
                            <th class="collapsing">수취인</th>
                            <th class="collapsing">수취인연락처</th>
                            <th class="collapsing">수취인주소</th>
                            <th class="collapsing">고객요청사항</th>
                            <th class="collapsing">메모</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in items" :key="index">
                            <td class="collapsing">{{ index + 1 }}</td>
                            <td class="collapsing">
                                {{ item.seller }}
                            </td>
                            <td :class="item.error.type ? 'red collapsing' : 'collapsing'">
                                <p>{{ constantNames[item.type] }}</p>
                                <div v-if="item.error.type" class="ui red label">{{ item.error.type }}</div>
                            </td>
                            <td class="collapsing"> {{ item.company }} </td>
                            <td class="collapsing"> {{ item.number }} </td>
                            <td class="collapsing">{{ item.orderedAt.format("yyyy-MM-dd(KS)") }}</td>
                            <td :class="item.error.product ? 'red collapsing' : 'collapsing'">
                                <p>{{ item.product }}</p>
                                <div v-if="item.error.product" class="ui red label">{{ item.error.product }}</div>
                            </td>
                            <td :class="item.error.count ? 'red collapsing' : 'collapsing'">
                                <p>{{ item.count }}</p>
                                <div v-if="item.error.count" class="ui red label">{{ item.error.count }}</div>
                            </td>
                            <td :class="item.error.orderer ? 'red collapsing' : 'collapsing'">
                                <p>{{ item.orderer }}</p>
                                <div v-if="item.error.orderer" class="ui red label">{{ item.error.orderer }}</div>
                            </td>
                            <td :class="item.error.ordererTel ? 'red collapsing' : 'collapsing'">
                                <p>{{ item.ordererTel }}</p>
                                <div v-if="item.error.ordererTel" class="ui red label">{{ item.error.ordererTel }}</div>
                            </td>
                            <td class="collapsing">
                                {{ item.receiver }}
                            </td>
                            <td class="collapsing">
                                {{ item.receiverTel }}
                            </td>
                            <td class="collapsing">
                                <p>{{ item.address }}</p>
                            </td>
                            <td class="collapsing"> {{ item.clientMemo }} </td>
                            <td class="collapsing"> {{ item.partnerMemo }} </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div id="footer" class="ui bottom fixed text menu">
                <div class="right menu">
                    <div class="item" v-if="isUploadReady">
                        <input type="file" @change="onOpenExcelFile">
                    </div>
                    <div class="item">
                        <div class="ui teal button" @click="add">단건추가</div>
                    </div>
                    <div class="item" v-if="items.length > 0 && !hasError()">
                        <div class="ui orange button" @click="save">저장</div>
                    </div>
                    <div class="item">
                        <div class="ui button" @click="close">닫기</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

const moment = require("moment");

const INDEX = "#";
const SELLER = "판매처";
const TYPE = "타입";
const COMPANY = "택배사";
const NUMBER = "운송장번호";
const DATE = "주문날짜";
const PRODUCT = "상품명";
const COUNT = "수량";
const ORDERER = "주문자";
const ORDERER_TEL = "주문자연락처";
const RECEIVER = "수취인";
const RECEIVER_TEL = "수취인연락처";
const ADDRESS = "수취인주소";
const CLIENT_MEMO = "고객요청사항";
const PARTNER_MEMO = "메모";

export default {
    data: function() {
        return {
            showModal: 0, items: 0, fileName: 0, isUploadReady: 0, onChange: 0, 
        }
    },
    created: function() {
        this.showModal = false;
        this.$event.set("parcelOrder_new", this.open);
    },
    mounted: function() {
        window.addEventListener('keyup', (e) => { if (this.showModal && e.keyCode === 27) this.close(); });
    },
    destroyed: function() {
        this.$event.clear("parcelOrder_new");
    },
    methods: {
        open(onChange) {
            this.showModal = true;
            this.items = [];
            this.fileName = "";
            this.onChange = onChange;
            this.reloadFile();
        },
        close() {
            this.showModal = false;
        },
        save() {
            if (this.items.length > 0) {
                this.$event.call("openLoading");
                this.$api.createParcelOrder(this.user._id, this.items, (resData) => {
                    this.$event.call("closeLoading");
                    if (resData.error) {
                        alert(resData.error.message);
                    } else {
                        if (this.onChange) this.onChange();
                        this.close();
                    }
                });
            }
        },
        add() {
            this.$event.call("open_add_parcel", this.user, (newItem) => {
                newItem.error = {};
                this.checkError(newItem);
                this.items.push(newItem);
            });
        },
        reloadFile() {
            this.isUploadReady = false;
            this.$nextTick(() => this.isUploadReady = true);
        },
        checkError(item) {
            item.error = {};
            if (item.count <= 0) { item.error.count = "개수에러"; }
            if (!this.constantNames[item.type]) { item.error.type = "타입에러"; }
            if (!this.hasProduct(item.product)) { item.error.product = "상품에러"; }
            if (!Boolean(item.orderer)) { item.error.orderer = "입력에러"; }
            if (!Boolean(item.ordererTel)) { item.error.ordererTel = "입력에러"; }
        },
        hasError() {
            for (const item of this.items) {
                if (item.error && Object.keys(item.error).length > 0) return true;
            }
            return false;
        },
        onOpenExcelFile() {
            this.fileName = event.target.files[0].name;
            this.$event.call("openLoading");
            this.$excel.readFile(event.target.files[0], (excelData) => {
                this.items = [];
                for (const data of excelData) {
                    const newItem = {};

                    newItem.type = this.getTypeFromExcel(data[TYPE]);
                    newItem.number = data[NUMBER];
                    newItem.company = data[COMPANY];
                    newItem.seller = data[SELLER];
                    newItem.orderedAt = moment(new Date(data[DATE])).add(1, 'm').toDate();
                    newItem.product = this.getProductFromExcel(data[PRODUCT]);
                    newItem.count = parseInt(data[COUNT]);
                    newItem.orderer = data[ORDERER];
                    newItem.ordererTel = data[ORDERER_TEL];
                    newItem.receiver = data[RECEIVER];
                    newItem.receiverTel = data[RECEIVER_TEL];
                    newItem.address = data[ADDRESS];
                    newItem.clientMemo = data[CLIENT_MEMO];
                    newItem.partnerMemo = data[PARTNER_MEMO];
                    newItem.error = {};
                    this.checkError(newItem);
                    this.items.push(newItem);
                }
                this.reloadFile();
                this.$event.call("closeLoading");
            });
        },
        getTypeFromExcel(typeText) {
            if (typeText) {
                switch (typeText.replace(/\s/g, "").toUpperCase()) {
                    case "택배": return this.constant.TYPE_PARCEL;
                    case "교환": return this.constant.TYPE_EXCHANGE;
                    case "회수": return this.constant.TYPE_RECALL;
                    case "A/S": return this.constant.TYPE_AS;
                    case "쿠팡": return this.constant.TYPE_COUPANG;
                }
            }
            return -1;
        },
        getProductFromExcel(productText) {
            return productText ? productText.replace(/\s/g, "").toUpperCase() : "";
        },
        hasProduct(name) {
            if (this.products) {
                for (var p of this.products) {
                    if (p.name === name) return true;
                }
            }
            return false;
        },
    },
    computed: {
        user: function() { return this.$store.getters.user; },
        products: function() { return this.$store.getters.products; },
        constant: function() { return this.$store.getters.constant; },
        constantNames: function() { return this.$store.getters.constantNames; },
    },
}
</script>

<style>
#parcel_order_modal {
    position: fixed;
    left: 0;
    top: 0;
    margin: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: #fff;
}

#parcel_order_modal .column {
    min-width: 100%;
    max-width: 100%;
}

#parcel_order_modal #header {
    padding: 20px 30px;
}

#parcel_order_modal #body {
    margin: 80px 0;
    width: 100%;
    font-size: 12px;
    overflow: auto;
}

#parcel_order_modal #header {
    padding: 20px 30px;
}

#parcel_order_modal #footer {
    padding: 20px 30px;
    background-color: #eee;
}

#parcel_order_modal .ui.form {
    padding: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/ParcelOrderModal_New.vue